// Constants and Utils
import {
  LocalStorageKeys,
  OrganizationIdsMapping,
  UserRoles,
} from "../../constants/GeneralConstants";
import { getItem } from "../../utils/localstorage";
import { checkIsOrgSpecific } from "../../utils/OrgUtils";

// construct user Price Enabled Cities
export function constructUserPriceEnabledCities(
  regionsName = [],
  priceEnabledCityIds = []
) {
  if (!regionsName || regionsName.length === 0) {
    return [];
  }

  // get cities with id and label
  const filteredCities = regionsName.filter((region) =>
    priceEnabledCityIds.includes(region.id)
  );

  return filteredCities;
}

// checking user have only MonitoringJob(app) access
// Only MonitoringJob Access Roles = [ROLE_USER, ROLE_MON_USER];
export function checkIsOnlyMonitoringJobUser(roles = []) {
  // user roles
  const { ROLE_USER, ROLE_MON_USER } = UserRoles || {};

  // Condition: user has only [ROLE_USER + ROLE_MON_USER]
  const hasOnlyMonitoringJobAccess =
    roles.length === 2 &&
    roles.includes(ROLE_USER) &&
    roles.includes(ROLE_MON_USER);

  // return boolean
  return hasOnlyMonitoringJobAccess;
}

// checking is coralMedia Org specific
export function checkIsCoralMediaSpecific() {
  // coral media
  const user = JSON.parse(getItem(LocalStorageKeys.USER));
  const { orgId } = user || {};
  const { coralMedia } = OrganizationIdsMapping;
  const isCoralMediaSpecific = checkIsOrgSpecific(orgId, coralMedia);

  return isCoralMediaSpecific;
}

// checking LoggedIn User is AdminUser
export function checkIsLoggedInUserAdminUser() {
  // user
  const user = JSON.parse(getItem(LocalStorageKeys.USER));
  const { isAdminUser } = user || {};
  return isAdminUser || false;
}
